export default __webpack_public_path__ + "images/c4effadee6885b0e086b83f3b1dbe8c7.svg";